<template>
  <el-container style="width: 100vw;height: 100vh;">
  <el-aside width="200px">
     <div
            style="height: 60px;background: linear-gradient(132deg, #44DB90 0%, #2CCC7C 100%);opacity: 1;">
          <div style="padding-top: 8%;">
            <img src="./assets/logo@2x.png" style="width: 16px;height: 22px"/>
            <span
                style="width: 144px;height: 21px;font-size: 16px;font-family: AliHYAiHei-Beta;font-weight: bold;line-height: 21px;color: #FFFFFF;opacity: 1;">
            春播万象大数据平台
          </span>
          </div>
        </div>
        <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        <el-menu
                :default-active="$route.path"
                class="el-menu-vertical-demo"
                mode="vertical"
                @select="handleSelect"
                background-color="#2A2E39"
                text-color="#fff" :collapse="isCollapse"
                active-text-color="#5CE5A5">

              <el-submenu index="admin" v-if="menus.indexOf('/admin')>-1">
                <template slot="title">
                  <i class="el-icon-admin"></i>
                  <span slot="admin">管理视角</span>
                </template>
                <el-menu-item index="/admin/admin_report_home" v-if="menus.indexOf('/admin/admin_report_home')>-1">
                  <router-link to="/admin/admin_report_home" tag="li" active-class="active">综合报告</router-link>
                </el-menu-item>
                <el-menu-item index="/admin/admin_desc_view" v-if="menus.indexOf('/admin/admin_desc_view')>-1">
                  <router-link to="/admin/admin_desc_view" tag="li" active-class="active">描述性统计</router-link>
                </el-menu-item>
                <el-menu-item index="/admin/admin_diagnose_view" v-if="menus.indexOf('/admin/admin_diagnose_view')>-1">
                  <router-link to="/admin/admin_diagnose_view" tag="li" active-class="active">诊断性分析</router-link>
                </el-menu-item>
                <el-menu-item index="/admin/admin_trigger_view" v-if="menus.indexOf('/admin/admin_trigger_view')>-1">
                  <router-link to="/admin/admin_trigger_view" tag="li" active-class="active">触发式分析</router-link>
                </el-menu-item>
                <el-menu-item index="/admin/admin_predict_view" v-if="menus.indexOf('/admin/admin_predict_view')>-1">
                  <router-link to="/admin/admin_predict_view" tag="li" active-class="active">预测式分析</router-link>
                </el-menu-item>

              </el-submenu>

              <el-submenu index="patient" v-if="menus.indexOf('/patient')>-1">
                <template slot="title">
                  <i class="el-icon-patient"></i>
                  <span slot="patient">用户信息</span>
                </template>
                <el-menu-item index="/patient/patient_list" v-if="menus.indexOf('/patient/patient_list')>-1">
                  <router-link to="/patient/patient_list" tag="li" active-class="active">用户总览</router-link>
                </el-menu-item>
                 <el-submenu index="patient">
                    <template slot="title">用户示例</template>
                     <el-menu-item index="/patient/basic" v-if="menus.indexOf('/patient/basic')>-1">
                  <router-link to="/patient/basic?patient_id=2049104109349707778" tag="li" active-class="active">基本信息</router-link>
                </el-menu-item>
                <el-menu-item index="/patient/health" v-if="menus.indexOf('/patient/health')>-1">
                  <router-link to="/patient/health" tag="li" active-class="active">健康状况</router-link>
                </el-menu-item>
                <!-- <el-menu-item index="/patient/rec" v-if="menus.indexOf('/patient/rec')>-1">
                  <router-link to="/patient/rec" tag="li" active-class="active">健康++</router-link>
                </el-menu-item> -->
                  </el-submenu>
              </el-submenu>

              <el-submenu index="clinic" v-if="menus.indexOf('/clinic')>-1">
                <template slot="title">
                  <i class="el-icon-clinic"></i>
                  <span slot="clinic">诊所信息</span>
                </template>
                <el-menu-item index="/clinic/clinic_list" v-if="menus.indexOf('/clinic/clinic_list')>-1">
                  <router-link to="/clinic/clinic_list" tag="li" active-class="active">诊所总览</router-link>
                </el-menu-item>
                 <el-submenu index="clinic">
                    <template slot="title">诊所示例</template>
                  <el-menu-item index="/clinic/clinic_info" v-if="menus.indexOf('/clinic/clinic_info')>-1">
                    <router-link to="/clinic/clinic_info" tag="li" active-class="active">基本信息</router-link>
                  </el-menu-item>
                  <el-menu-item index="/clinic/clinic_doctor_stat" v-if="menus.indexOf('/clinic/clinic_doctor_stat')>-1">
                    <router-link to="/clinic/clinic_doctor_stat" tag="li" active-class="active">诊所医生画像</router-link>
                  </el-menu-item>
                  <el-menu-item index="/clinic/clinic_drug_stat" v-if="menus.indexOf('/clinic/clinic_drug_stat')>-1">
                    <router-link to="/clinic/clinic_drug_stat" tag="li" active-class="active">诊所药物画像</router-link>
                  </el-menu-item>
                  <el-menu-item index="/clinic/clinic_acupoint_stat"
                                v-if="menus.indexOf('/clinic/clinic_acupoint_stat')>-1">
                    <router-link to="/clinic/clinic_acupoint_stat" tag="li" active-class="active">诊所贴敷画像</router-link>
                  </el-menu-item>
                 </el-submenu>
              </el-submenu>

              <el-submenu index="profile" v-if="menus.indexOf('/profile')>-1">
                <template slot="title">
                  <i class="el-icon-profile"></i>
                  <span slot="profile">用户画像</span>
                </template>
                <el-menu-item index="/profile/profile_global" v-if="menus.indexOf('/profile/profile_global')>-1">
                  <router-link to="/profile/profile_global" tag="li" active-class="active">画像首页</router-link>
                </el-menu-item>
                <el-menu-item index="/profile/profile_chronic_disease_view"
                              v-if="menus.indexOf('/profile/profile_chronic_disease_view')>-1">
                  <router-link to="/profile/profile_chronic_disease_view" tag="li" active-class="active">慢性病
                  </router-link>
                </el-menu-item>
              </el-submenu>


              <el-submenu index="service" v-if="menus.indexOf('/service')>-1">
                <template slot="title">
                  <i class="el-icon-outservice"></i>
                  <span slot="service">对外服务</span>
                </template>
                <!--                <el-menu-item index="/service/ensurance">-->
                <!--                  <router-link to="/service/ensurance" tag="li" active-class="active">保险服务</router-link>-->
                <!--                </el-menu-item>-->
                <!--                <el-menu-item index="/service/finiance">-->
                <!--                  <router-link to="/service/finiance" tag="li" active-class="active">金融服务</router-link>-->
                <!--                </el-menu-item>-->
                <el-menu-item index="/service/entity" v-if="menus.indexOf('/service/entity')>-1">
                  <router-link to="/service/entity" tag="li" active-class="active">病例抽取服务</router-link>
                </el-menu-item>
                <el-menu-item index="/service/medical_sim_service"
                              v-if="menus.indexOf('/service/medical_sim_service')>-1">
                  <router-link to="/service/medical_sim_service" tag="li" active-class="active">相似病例匹配</router-link>
                </el-menu-item>
                <el-menu-item index="/service/user_disease_predict"
                              v-if="menus.indexOf('/service/user_disease_predict')>-1">
                  <router-link to="/service/user_disease_predict" tag="li" active-class="active">用户患病预测</router-link>
                </el-menu-item>
              </el-submenu>

              <!--              <el-submenu index="disease_anno" v-if="isAdmin">-->
              <!--                <template slot="title">-->
              <!--                  <i class="el-icon-diseaseano"></i>-->
              <!--                  <span slot="disease_anno">疾病症状标注服务</span>-->
              <!--                </template>-->
              <!--                <el-menu-item index="/disease_anno/disease_anno">-->
              <!--                  <router-link to="/disease_anno/disease_anno" tag="li" active-class="active">疾病症状标注服务</router-link>-->
              <!--                </el-menu-item>-->
              <!--              </el-submenu>-->


              <el-submenu index="largeScreenMonitor" v-if="menus.indexOf('/largeScreenMonitor')>-1">
                <template slot="title">
                  <i class="el-icon-largescreen"></i>
                  <span slot="largeScreenMonitor">大屏监控</span>
                </template>
                <el-menu-item index="/largeScreenMonitor/largeScreenMonitor"
                              v-if="menus.indexOf('/largeScreenMonitor')>-1">
                  <router-link to="/largeScreenMonitor" tag="li" active-class="active">大屏监控</router-link>
                </el-menu-item>
              </el-submenu>


              <el-submenu index="data_processor" v-if="menus.indexOf('/data_processor')>-1">
                <template slot="title">
                  <i class="el-icon-dataprocess"></i>
                  <span slot="data_processor">数据处理</span>
                </template>
                <el-menu-item index="/data_processor/data_mixup" v-if="menus.indexOf('/data_processor/data_mixup')>-1">
                  <router-link to="/data_processor/data_mixup" tag="li" active-class="active">数据脱敏</router-link>
                </el-menu-item>
                <el-menu-item index="/data_processor/data_encrypt"
                              v-if="menus.indexOf('/data_processor/data_encrypt')>-1">
                  <router-link to="/data_processor/data_encrypt" tag="li" active-class="active">数据加密</router-link>
                </el-menu-item>
                <el-menu-item index="/data_processor/data_tracer"
                              v-if="menus.indexOf('/data_processor/data_tracer')>-1">
                  <router-link to="/data_processor/data_tracer" tag="li" active-class="active">数据溯源</router-link>
                </el-menu-item>
                <el-menu-item index="/data_processor/data_fillup"
                              v-if="menus.indexOf('/data_processor/data_fillup')>-1">
                  <router-link to="/data_processor/data_fillup" tag="li" active-class="active">地址补全</router-link>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="data_factory" v-if="menus.indexOf('/data_factory')>-1">
                <template slot="title">
                  <i class="el-icon-datafactory"></i>
                  <span slot="data_factory">数据工厂</span>
                </template>
                <el-menu-item index="/data_factory/hadoop" v-if="menus.indexOf('/data_factory/hadoop')>-1">
                  <a href="http://123.57.105.95:9088/filebrowser/#/user/hadoop" target="_blank" style="color: white;">跳转到HDFS</a>
                </el-menu-item>
                <el-menu-item index="/data_factory/spark" v-if="menus.indexOf('/data_factory/spark')>-1">
                  <a href="http://123.57.105.95:9001" target="_blank" style="color: white;">跳转到SparkNotebook</a>
                </el-menu-item>
                <el-menu-item index="/data_factory/hive" v-if="menus.indexOf('/data_factory/hive')>-1">
                  <a href="http://123.57.105.95:9088/notebook/editor?type=hive" target="_blank" style="color: white;">跳转到HIVE</a>
                </el-menu-item>
                <el-menu-item index="/data_factory/oltp" v-if="menus.indexOf('/data_factory/oltp')>-1">
                  <a href="http://123.57.105.95:9603/" target="_blank" style="color: white;">跳转到oltp系统</a>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="dataSearch" v-if="menus.indexOf('/dataSearch')>-1">
                <template slot="title">
                  <i class="el-icon-datasearch"></i>
                  <span slot="dataSearch">搜医搜</span>
                </template>
                <el-menu-item index="/dataSearch/dataSearch" v-if="menus.indexOf('/dataSearch')>-1">
                  <router-link to="/dataSearch/dataSearch" tag="li" active-class="active">搜医搜</router-link>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="dataPerf" v-if="menus.indexOf('/dataPerf')>-1">
                <template slot="title">
                  <i class="el-icon-perf"></i>
                  <span slot="dataPerf">性能监测</span>
                </template>
                <el-menu-item index="/dataPerf/dataPerf" v-if="menus.indexOf('/dataPerf')>-1">
                  <router-link to="/dataPerf/dataPerf" tag="li" active-class="active">性能监测</router-link>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="thirdParty" v-if="menus.indexOf('/thirdParty')>-1">
                <template slot="title">
                  <i class="el-icon-settings"></i>
                  <span slot="systemSettings">第三方数据接入</span>
                </template>
                <el-menu-item index="/thirdParty/tijian"
                              v-if="menus.indexOf('/thirdParty/tijian')>-1">
                  <router-link to="/thirdParty/tijian" tag="li" active-class="active">体检数据</router-link>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="systemSettings" v-if="menus.indexOf('/systemSettings')>-1">
                <template slot="title">
                  <i class="el-icon-settings"></i>
                  <span slot="systemSettings">权限设置</span>
                </template>
                <el-menu-item index="/systemSettings/userManager"
                              v-if="menus.indexOf('/systemSettings/userManager')>-1">
                  <router-link to="/systemSettings/userManager" tag="li" active-class="active">账号管理</router-link>
                </el-menu-item>
                <el-menu-item index="/systemSettings/roleManager"
                              v-if="menus.indexOf('/systemSettings/roleManager')>-1">
                  <router-link to="/systemSettings/roleManager" tag="li" active-class="active">角色管理</router-link>
                </el-menu-item>
              </el-submenu>

            </el-menu>
  </el-aside>
  <el-container>
    <el-header>
      <el-row>
      <el-col :span="18">
        <div style="width:100%;height: 60px;background-color: #373B46;">-</div>
      </el-col>
      <el-col :span="3">
        <div
            style="text-align: right;width:100%;background-color: #373B46;height: 60px;line-height: 60px;">
          <span v-if="isLoggedIn" class="exit_span">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link" style="color: white;font-size:16px">
                <img src="./assets/api_logo.png" style="height: 18px;width: 18px"/>
                开发API<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="change_api(item)" v-for="item in options_apis"
                                  :key="item.uid">
                        {{ item.api_name }}
                      </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
      </el-col>
      <el-col :span="3">
        <div
            style="text-align: center;width:100%;background-color: #373B46;height: 60px;line-height: 60px;">
          <span v-if="isLoggedIn" class="exit_span">
            <img src="./assets/exit.png" style="height: 18px;width: 18px"/>
            <a @click="logout"> 退出登录</a>
          </span>
        </div>
      </el-col>
    </el-row>
    </el-header>
    <el-main  style="text-align: left;display: inline-block;position: relative;height: calc(100vh - 60px);overflow: hidden;background-color: #373B46;" :style="{ overflow: $store.getters.loadingVisible ? 'hidden' : 'auto' }">
       <GlobalLoading></GlobalLoading>
        <router-view style="height: 100%;overflow: auto;"></router-view>
    </el-main>
  </el-container>
</el-container>
</template>

<script>
import {Role} from '@/./role';
import GlobalLoading from "./components/LoadingSpinner.vue";

export default {
  name: "MainPage",
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      options_apis: null,
      isCollapse: false,
      menus: [],
      loading: true,
    };
  },
  components:{
    GlobalLoading
  },
  computed: {
    // get_menus_perms: function () {
    //   let result=[]
    //   this.$http.get(process.env.VUE_APP_API_HOST + "api/get_user_menus_perms?user_id=6d6fff185695163d41b8645b169377e6").then((res) => {
    //         result= res['data']['data']['menus']
    //   })
    //   return result;
    // },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    isAdmin: function () {
      return this.$store.getters.user_role === Role.Admin
    },
    isPatient: function () {
      return this.$store.getters.user_role === Role.Patient
    },
    isClinic: function () {
      return this.$store.getters.user_role === Role.Clinic
    },
    isDev: function () {
      return this.$store.getters.user_role === Role.Dev
    },
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        console.log(resolve)
        console.log(reject)
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout")
        }
        throw err;
      });
    });
  },
  mounted() {
    this.get_apis();
    this.get_menus_perms();
  },
  methods: {
    get_menus_perms: function () {
      this.$http.get(process.env.VUE_APP_API_HOST + "/api/get_user_menus_perms?user_id="+this.$store.getters.user_id).then((res) => {
        this.menus = res['data']['data']['menus'] || []
      }).catch((err) => {
        console.error('获取菜单权限失败:', err)
        this.menus = []
      })
    },
    change_api(item) {
      window.open("/#/api/api?api_id=" + item.uid, '_blank');
    },
    get_apis() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/get_apis",).then((res) => {
        this.options_apis = res.data.data
      })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    logout: function () {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
    }
  },

}
</script>

<style>
#app1 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  width: 100vw;
}
.el-menu-vertical-demo{
  border-right: 1px solid #303133;
  max-height: calc(100vh - 60px);
  overflow: auto;
}
.exit_span {
  color: white;
  cursor: pointer;

}

.el-header, .el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: left;
  line-height: 60px;
  padding: 0 0px;
}

.el-aside {
  background-color: #2A2E39;
  color: #333;
  text-align: left;
  /*line-height: 200px;*/
}

.el-submenu .el-menu-item {
  min-width: auto;
}

.el-main {
  /*background-color: #E9EEF3;*/
  color: #333;
  text-align: left;
  /*line-height: 60px;*/
  padding: 0 0px;
}


body > .el-container {
  margin-bottom: 40px;
}

body {
  margin: 0px
}

.el-icon-patient {
  content: url("assets/svgs/icon-users.svg");
}

.el-icon-perf {
  content: url("assets/svgs/icon-perf.svg");
}

.el-icon-settings {
  content: url("assets/svgs/icon-setting.svg");
}

.active::before {
  content: "•";
  /*margin-right:10px*/
}

.el-icon-clinic {
  content: url("assets/svgs/clinic_icon.svg");
}

.el-icon-profile {
  content: url("assets/svgs/profile_icon.svg");
}

.el-icon-admin {
  content: url("assets/svgs/admin_icon.svg");
}

.el-icon-outservice {
  content: url("assets/svgs/outservice_icon.svg");
}

.el-icon-diseaseano {
  content: url("assets/svgs/diseaseano_icon.svg");
}

.el-icon-largescreen {
  content: url("assets/svgs/largescreen_icon.svg");
}

.el-icon-dataprocess {
  content: url("assets/svgs/dataprocess_icon.svg");
}

.el-icon-datafactory {
  content: url("assets/svgs/clinic_icon.svg");
}

.el-icon-datasearch {
  content: url("assets/svgs/datasearch_icon.svg");
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>

